import type { ReactNode } from 'react';
import { EntityMarkShape } from './entityMarkShapes';

export type EntityIconProps = {
  entityType: string | null | undefined;
  size?: number;
  color?: string;
  className?: string;
  stroke?: number;
};

/**
 * Entity glyph — unique solid shape per archetype (not stroke icons).
 * Kept name `EntityIcon` for call-site compatibility.
 */
export function EntityIcon({
  entityType,
  size = 16,
  color = 'currentColor',
  className,
}: EntityIconProps): ReactNode {
  return (
    <EntityMarkShape entityType={entityType} size={size} color={color} className={className} />
  );
}

/** @deprecated Prefer EntityMarkShape / EntityIcon — shape key comes from registry. */
export function getEntityIconComponent(_entityType: string | null | undefined) {
  return EntityIcon;
}
